module.exports = __webpack_public_path__ + "static/media/office2.d57fa885.jpg";